export default [
  {
    path: '/AdminLogin',
    name: 'Login',
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Top',
    name: 'Top',
    component: () => import('@/components/functions/Top/TopIndex')
  },
  {
    path: '/D0101Demo',
    name: 'D0101Demo',
    component: () => import('@/components/functions/D0101Demo/D0101DemoIndex')
  },
  {
    path: '/M0001User',
    name: 'M0001User',
    component: () => import('@/components/functions/M0001User/M0001UserIndex')
  },
  {
    path: '/Admin',
    name: 'Admin',
    component: () => import('@/components/functions/A0001Admin/A0001AdminIndex')
  },
  {
    path: '/PurchaseList',
    name: 'PurchaseList',
    component: () => import('@/components/functions/A0001Admin/A0001AdminViewPurchase')
  },
  {
    path: '/ManageProduct',
    name: 'ManageProduct',
    component: () => import('@/components/functions/A0001Admin/A0001AdminManageProduct')
  },
  {
    path: '/ManageFrame',
    name: 'ManageFrame',
    component: () => import('@/components/functions/M0005Frame/M0005FrameIndex')
  },
  {
    path: '/M0002LandingPage',
    name: 'M0002LandingPage',
    component: () => import('@/components/functions/M0002LandingPage/M0002LandingPageIndex')
  },
  /*
  {
    path: '/Product/:id',
    name: 'Product',
    component: () => import('@/components/functions/M0002LandingPage/M0002LandingPageProduct')
  },
  {
    path: '/ShoppingCart',
    name: 'M0003ShoppingCart',
    component: () => import('@/components/functions/M0003ShoppingCart/M0003ShoppingCartIndex')
  },
  {
    path: '/Purchase/:id',
    name: 'M0004Purchase',
    component: () => import('@/components/functions/M0004Purchase/M0004PurchaseForm')
  },
  */
  {
    path: '/ProductList',
    name: 'ProductList',
    component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopIndex')
  },
  {
    path: '/Product/:id/:name',
    name: 'Product',
    component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopProductDetail')
  },
  {
    path: '/ShoppingCart',
    name: 'ShoppingCart',
    component: () => import('@/components/functions/M0008ShoppingCart/CartIndex')
  },
  {
    path: '/CheckOut',
    name: 'CheckOut',
    component: () => import('@/components/functions/M0009CheckOut/CheckOutIndex')
  },
  {
    path: '/ShoppingCart/:status',
    name: 'Payment',
    component: () => import('@/components/functions/M0008ShoppingCart/CartIndex')
  },
  {
    path: '/PurchaseDetail/Received/:p0201_id/:purchase_num/:temp_token',
    name: 'PurchaseDetail',
    component: () => import('@/components/functions/M0009CheckOut/PurchaseReceived')
  },
  {
    path: '/Survey/:id',
    name: 'Survey',
    component: () => import('@/components/functions/M0601Survey/M0601SurveyIndex')
  },
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopIndex')
  },
  {
    path: '*',
    redirect: '/'
  }
]
